import React, {useState, useEffect, useContext, useRef} from 'react';
import Navbar1 from './Navbar1';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {Document, Page, pdfjs} from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import EditSharp from '@mui/icons-material/EditSharp';
import { useTranslation } from 'react-i18next';
import {useReactToPrint} from 'react-to-print';
import {
    doc,
    getDoc,
    serverTimestamp,
    setDoc,
    addDoc,
    collection
  } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { toast } from 'react-toastify';
import { reset } from '../../features/auth/authSlice';
import { AuthContext } from "../../context/AuthContext";
import config from '../../config';
import Sidebar from './Sidebar';
import emailController from '../../controllers/emailController';

var url = config.nav.url;

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
let id = '';
const Step9 = () => {
    const { t } = useTranslation();
    if(localStorage.getItem('id') != null){
        id = localStorage.getItem('id');
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {currentUser} = useContext(AuthContext);
    const type = localStorage.getItem("type");
    const componentRef = useRef();

    var today = Date();
    var lastDay = '01/30/2023';
    const [per, setPerc] = useState(null);
    const [data, setData] = useState({});
    
    const [isLoading, setIsLoading] = useState(false);

    // submissions
    const [submitForm, setForm] = useState("");
    const [attestation, setAttestation] = useState("");
    const [birthCert, setBirthCert] = useState("");
    const [resume, setResume] = useState("");
    const [proposition, setProposition] = useState("");

    const [documents, setDocuments] = useState({
        form : '',
        attestation: '',
        birthdayCert: '',
        resume: '',
        proposition: '',
        budget: '',
        matrice: ''
    });

    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });

    const [status, setEnabled] = useState({
        submitted: false,
    });

    const [deadline, setDeadline] = useState({
        isPassed: true,
        value: true
    });

    const { usr, isError, isSuccess, message} = useSelector(
        (state) => state.auth
      )

    const [form, setError] = useState({
        error: false,
    });

    const [user, setUser] = useState({
        id: '',
        title : '',
        grade : '',
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        whatsapp: '',
        theme: ''
    });

    const [step1, setStep1] = useState({
        lastName: '',
        firstName: '',
        birthday: '',
        gender: '',
        specialty: '',
        structure: '',
        diplome: '',
        mbr1Name: '',
        mbr1Title: '',
        mbr1Grade: '',
        mbr1Specialty: '',
        mbr1Gender: '',
        mbr2Name: '',
        mbr2Title: '',
        mbr2Grade: '',
        mbr2Specialty: '',
        mbr2Gender: '',
        mbr3Name: '',
        mbr3Title: '',
        mbr3Grade: '',
        mbr3Specialty: '',
        mbr3Gender: '',
        theme: 'Aucune thématique choisie'
    });

    const [step2, setStep2] = useState({
        title : '',
        titleShort : '',
        resume: '',
        context: '',
        objective: '',
        result: '',
        amount: '',
        duration : ''
    });

    const [step3, setStep3] = useState({
        state : '',
        description : '',
        advantages: '',
        materials: '',
        methodology: ''
    });

    const [step4, setStep4] = useState({
        activities : '',
        calendarUrl : '',
        matrixUrl: '',
        budgetUrl: ''
    });

    const [step5, setStep5] = useState({
        means : '',
        patentNumber : '',
        patentManagement: ''
    });

    const [step6, setStep6] = useState({
        publishings : '',
        patents : ''
    });

    const [step7, setStep7] = useState({
        img : '',
        timeStamp: null
    });

    const [step8, setStep8] = useState({
        partner: '',
        img : '',
        timeStamp: null
    });

    const getStatus = async () => {
        try {
            const userRef = doc(db, "submissions", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists() && userSnap.data().id.length < 1){
                status.submitted = true;
                setEnabled({...status, [status]:true})
            }
            
        } catch (error) {
            console.log(error);
        }
    };

    const getUserDetails = async () => {
        try {
            const userRef = doc(db, "users", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
            return userSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    // get step details
    const getStep1Details = async () => {
        try {
            const stepRef = doc(db, "step1", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getStep2Details = async () => {
        try {
            const stepRef = doc(db, "step2", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getStep3Details = async () => {
        try {
            const stepRef = doc(db, "step3", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getStep4Details = async () => {
        try {
            const stepRef = doc(db, "step4", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getStep5Details = async () => {
        try {
            const stepRef = doc(db, "step5", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getStep6Details = async () => {
        try {
            const stepRef = doc(db, "step6", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getStep7Details = async () => {
        try {
            const stepRef = doc(db, "step7", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getStep8Details = async () => {
        try {
            const stepRef = doc(db, "step8", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
                return stepSnap.data();
            }
            else{
                form.error = true;
                setError({...form, [form]:true})
                 return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                // window.alert('Pas de connexion internet')
                form.error = true;
                setError({...form, [form]:true})
            }
            else{
                window.alert(error)
            }
        }
    };

    const getAllDetails = async () => {
        await getUserDetails().then(data => {
            if(data != null){
                setUser(data);
                if(data.title.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.grade.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.lastName.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.firstName.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.email.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.phone.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.whatsapp.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
        await getStep1Details().then(data => {
            if(data != null){
                setStep1(data)
                if(data.lastName.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.firstName.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.birthday.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.gender.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.specialty.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.structure.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.diplome.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.mbr1Name.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.mbr1Title.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.mbr1Grade.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.mbr1Specialty.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.mbr1Gender.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
        await getStep2Details().then(data => {
            if(data != null){
                setStep2(data)
                if(data.title.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.titleShort.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.resume.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.context.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.objective.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.result.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.amount.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.duration.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
        await getStep3Details().then(data => {
            if(data != null){
                setStep3(data)
                if(data.state.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.description.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.advantages.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.materials.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.methodology.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
        await getStep4Details().then(data => {
            if(data != null){
                setStep4(data)
                if(data.activities.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.calendarUrl.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.matrixUrl.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
                else if(data.budgetUrl.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
        await getStep5Details().then(data => {
            if(data != null){
                setStep5(data)
                if(data.patentNumber.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
        await getStep6Details().then(data => {
            if(data != null){
                setStep6(data);
            }
        });
        await getStep7Details().then(data => {
            if(data != null){
                setStep7(data)
                if(data.img.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
        await getStep8Details().then(data => {
            if(data != null){
                setStep8(data)
                if(data.partner.toString().includes("yes") && data.img.length < 1){
                    form.error = true;
                    setError({...form, [form]:true})
                }
            }
        });
    };
    
    useEffect(() => {
        // restrict access for examinators
        if(type === 'exam'){
            navigate('/admin')
        }

        // getting user details
        if(firstRender){
            deadline.isPassed = Date.parse(today) > Date.parse(lastDay);
            deadline.value = Math.round((Date.parse(lastDay) - Date.parse(today)) / (1000 * 60 * 60 * 24));
            setDeadline(deadline);
            getStatus();
            getAllDetails().then(data => {
                setFirstRender(false);
            });
        }

        if (isError) {
        toast.error(message)
        }

        if (isSuccess || usr) {
            navigate("/step1")
        }
        dispatch(reset())
  }, [user, isError, isSuccess, message, firstRender, dispatch])

    // Handle Submit
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    // Handle Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        if(window.confirm("Voulez-vous soumettre votre candidature ?")){
            setIsLoading(true);
            // save submissions
            user.theme = step1.theme;
            try {
                await setDoc(doc(db, "submissions", id), {
                  ...user,
                  timeStamp: serverTimestamp(),
                });

                // save user documents
                await Promise.all(
                    [submitForm, attestation, birthCert, resume, proposition].map(async file => {
                      const fileName = `${file.name}`;
                      const storageRef = ref(storage, `files/submissions/${user.id}/${fileName}`);
                      try {
                        uploadBytes(storageRef, file).then((snapshot) => {
                            getDownloadURL(snapshot.ref).then( async (downloadURL) =>{
                                const item = {
                                    url: downloadURL,
                                    path: fileName,
                                    uploadedAt: serverTimestamp(),
                                };
                                await addDoc(collection(db, `submissions/${user.id}/documents`), {
                                    ...item
                                });
                            });
                        });
                        
                      } catch (e) {
                        window.alert('Une erreur a été produite !');
                      }
                    })
                  );
                await emailController.sendEmailToCandidate(currentUser).then(ans => {
                    if(ans){
                        window.alert('Candidature enregistrée avec succès !');
                        navigate("/dashboard");
                    }
                    else{
                        window.alert('Une erreur est survenue, veuillez essayer plus tard !');
                    }
                })
                form.error = true;
                setError({...form, [form]:true});
                getStatus();
            } catch (error) {
                setIsLoading(false);
                if(error.toString().includes("offline")){
                    window.alert('Pas de connexion internet')
                }
                else{
                    window.alert(error)
                }
            }
        }
    }

    return (
        <div>
            <Navbar1/>
            <div className="container m-5">
                <div className="row">
                    <div className='col-md-3 mt-4'>
                        <div className="row cadre">
                            <p className="mt-3 pt-0 text-white fw-bolder" id="dashb">{t('application')}</p>
                            <div className="m-3 mt-0 mb-0">
                                <Sidebar/>    
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 p-4">
                        <p className="lead fs-1">{t('menu_9')}</p><br />
                        
                            <div ref={componentRef}>
                                {/* <div className="d-flex justify-content-between pt-4 banner">
                                    <img src="/assets/partners/kongo.png" alt="About" className="img-banner pe-2"/>
                                    <img src="/assets/partners/edenafrica.png" alt="About" className="img-banner pe-2"/>
                                    <img src="/assets/partners/ewb.png" alt="About" className="img-banner pe-2"/>
                                    <img src="/assets/partners/ifdd.png" alt="About" className="img-banner pe-2"/>
                                    <img src="/assets/logo.png" alt="About" className="img-banner"/>
                                </div> */}
                                <br />
                                <div className="banner">
                                    <h2 className='mb-4 text-center'>{t('application_form')}</h2>
                                    <h1 className="fw-bolder text-center title">APAFReP</h1>
                                    <p className="mb-4 text-center">{t('banner_title')}</p>
                                </div>
                                <table className='banner'>
                                        <tr>
                                            <td className='step-title first'>
                                                <p>{t('step_0')}</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step0")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead first">{t('step_0_text')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.title.length < 1?
                                                                'error'
                                                                    :
                                                                'fw-bolder'
                                                            }>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.title}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.grade.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.grade}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.lastName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('names')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.lastName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.firstName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('first_names')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.firstName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.email.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('email_address')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.email}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.phone.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('phone')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.phone}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.whatsapp.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>Whatsapp </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.whatsapp}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step_1')}</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step1")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_1_text')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.lastName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_leader_name')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.lastName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.firstName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_leader_first_name')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.firstName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.birthday.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('birth_day')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.birthday}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.gender.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('gender')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.gender}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.specialty.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('specialty')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.specialty}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.structure.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('assignment_structure')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.structure}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.diplome.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('highest_diploma')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.diplome}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <div className="lead first px-3">{t('project_team_presentation')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <div className="px-4">- {t('member')} 1</div>
                                                        <span className={step1.mbr1Name.length < 1?
                                                                'error'
                                                                    :
                                                                'fw-bolder'
                                                            }>{t('first_last_name')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Title.length < 1?
                                                                'error'
                                                                    :
                                                                'fw-bolder'
                                                            }>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Title}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Grade.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Grade}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Specialty.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('specialty')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Specialty}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Gender.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('gender')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Gender}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <div className="px-4">- {t('member')} 2</div>
                                                        <span className='fw-bolder'>{t('first_last_name')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Title : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Grade : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('specialty')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Specialty : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('gender')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Gender : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <div className="px-4">- {t('member')} 3</div>
                                                        <span className='fw-bolder'>{t('first_last_name')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Title : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Grade : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('specialty')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Specialty : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('gender')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Gender : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.theme.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>- {t('theme')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.theme}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 2</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step2")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_2_text')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.title.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_title')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.title}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.titleShort.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('title_abbreviation')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.titleShort}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.resume.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_summary')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.resume}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.context.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('context')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.context}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.objective.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('objective')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.objective}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.result.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('expected_result')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.result}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.amount.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('amount_requested')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.amount}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.duration.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('implementation_time')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.duration}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 3</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step3")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_3_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.state.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('state_art')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.state}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.description.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('brief_description')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.description}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.advantages.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('advantages')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.advantages}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.materials.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('materials')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.materials}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.methodology.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('methodology')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.methodology}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 4</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step4")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_4_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.activities.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_activities')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step4.activities}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.calendarUrl.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('text_6_4')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step4.calendarUrl} className='deco_null' target="_blank" rel='noreferrer'>
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.matrixUrl.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('matrix')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step4.matrixUrl} className='deco_null' target="_blank" rel='noreferrer'>
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.budgetUrl.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('detailed_budget')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step4.budgetUrl} className='deco_null' target="_blank" rel='noreferrer'>
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 5</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step5")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_5_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('means_result')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step5.means}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step5.patentNumber.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('potential_patents')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step5.patentNumber}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('patent_management')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step5.patentManagement}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 6</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step6")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_6_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step6.publishings.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('scientific_publications')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step6.publishings}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step6.patents.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('patents')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step6.patents}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 7</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step7")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_7_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step7.img !== undefined && step7.img.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>
                                                            {t('table')}
                                                        </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step7.img} className='deco_null' target="_blank" rel="noreferrer">
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 8</p>
                                                <EditSharp className="icon pointer" onClick={()=>{navigate("/step8")}}/>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_8_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step8.partner.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('sme_partner')} ? </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {
                                                            step8.partner.includes("yes") ?
                                                            t('yes')
                                                            :
                                                            t('no')
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step8.img.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>
                                                            {
                                                                step8.partner.includes("yes") ?
                                                                t('cover_letter')
                                                                :
                                                                ''
                                                            }
                                                        </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                            {step8.partner.includes("yes") ? 
                                                                <a href={step8.img} className='deco_null' target="_blank" rel="noreferrer">
                                                                    {t('download')}
                                                                </a>
                                                            : <></>}
                                                        </td>
                                                </tr>
                                            </td>
                                        </tr>                                    
                                </table>
                                {/* <div className="d-flex justify-content-between pt-4 banner">
                                    <img src="/assets/partners/oeacp.png" alt="About" className="img-banner pe-2"/>
                                    <img src="/assets/partners/acp.png" alt="About" className="img-banner pe-2"/>
                                    <img src="/assets/partners/francophonie.png" alt="About" className="img-banner pe-2"/>
                                    <img src="/assets/partners/ue.jpg" alt="About" className="img-banner"/>
                                </div> */}
                                <br />

                            </div>
                                <div className="d-flex justify-content-center banner">
                                    <div className="me-4">
                                        <input type="submit" disabled={form.error || status.submitted || deadline.value <= 0} className='btn btn-primary'  id="vehicle1" name="vehicle1" value={t('print')} onClick={handlePrint}/>
                                    </div>
                                </div>
                                <br /><br />
                                <div className="cadre p-4">
                                    <h2>{t('application_documents')} </h2>
                                    <h5 className='text-danger'>({t('name_files')})</h5>
                                    <br />
                                    <form onSubmit={()=>{}}>
                                        <div className="formInput">
                                            <label htmlFor="file">
                                                <span className={submitForm !== undefined &&  submitForm.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('application_form')}:</span> &nbsp;
                                            </label>
                                            <input
                                            type="file"
                                            id="submitForm"
                                            accept='.pdf'
                                            
                                            onChange={(e) => setForm(e.target.files[0])}
                                            />
                                        </div>
                                        <br />
                                        <div className="formInput">
                                            <label htmlFor="file">
                                            <span className={attestation !== undefined &&  attestation.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('certificate_effective_presence')}:</span> &nbsp; 
                                            </label>
                                            <input
                                            type="file"
                                            id="attestation"
                                            accept='.pdf'
                                            onChange={(e) => setAttestation(e.target.files[0])}
                                            />
                                        </div>
                                        <br />
                                        <div className="formInput">
                                            <label htmlFor="file">
                                                <span className={birthCert !== undefined &&  birthCert.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('text_4_11')}: &nbsp;</span> &nbsp; 
                                            </label>
                                            <input
                                            type="file"
                                            id="file"
                                            accept='.pdf,.png, .jpg'
                                            onChange={(e) => setBirthCert(e.target.files[0])}
                                            />
                                        </div>
                                        <br />
                                        <div className="formInput">
                                            <label htmlFor="file">
                                                <span className={resume !== undefined &&  resume.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>Curriculum Vitae: &nbsp;</span> &nbsp; 
                                            </label>
                                            <input
                                            type="file"
                                            id="file"
                                            accept='.pdf'
                                            onChange={(e) => setResume(e.target.files[0])}
                                            />
                                        </div>
                                        <br />
                                        <div className="formInput">
                                            <label htmlFor="file">
                                                <span className={proposition !== undefined &&  proposition.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('micro_project_document')}: &nbsp;</span> &nbsp; 
                                            </label>
                                            <input
                                            type="file"
                                            id="file"
                                            accept='.pdf'
                                            onChange={(e) => setProposition(e.target.files[0])}
                                            />
                                        </div>
                                        <br /><br />
                                        <div className="ms-4">
                                            <input type="submit" disabled={
                                                form.error || 
                                                status.submitted || deadline.value <= 0 || 
                                                (submitForm.length < 1 || attestation.length   < 1 || birthCert.length   < 1 || resume.length   < 1 || proposition.length   < 1) 
                                            } className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('submit')} onClick={handleSubmit}/>
                                        </div>
                                    </form>
                                </div>
                    </div>
                </div>
                <div className="space"/>
            </div>
        </div>
    )
}

export default Step9;
